import { api } from "@/lib/api";
import { toast } from "sonner";
import { errMsg } from "@/components/email/EmParts";

export async function downloadCsv(params, name = "subscribers.csv") {
  try {
    const { data } = await api.get("/email-marketing/export", { params, responseType: "blob" });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url; a.download = name; a.click();
    URL.revokeObjectURL(url);
  } catch (e) {
    const t = e.response?.data instanceof Blob ? JSON.parse(await e.response.data.text()).detail : errMsg(e);
    toast.error(t || "Export failed");
  }
}
